import { render, staticRenderFns } from "./FeaturedFunds.vue?vue&type=template&id=058432ca&lang=pug"
import script from "./FeaturedFunds.vue?vue&type=script&lang=js"
export * from "./FeaturedFunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports